import { TFunction } from 'i18next'

import { PersonScreeningStatus, RiskGroupStatus } from 'src/api/requests'

export const getRiskGroupStatus = (t: TFunction, status: RiskGroupStatus) => {
  const statusMap = {
    [RiskGroupStatus.NEW]: {
      color: 'gold',
      text: t('pre_screening.new')
    },
    [RiskGroupStatus.SENT]: {
      color: 'green',
      text: t('pre_screening.sent')
    }
  }

  return {
    color: statusMap[status].color ?? 'red',
    text: statusMap[status].text ?? t('pre_screening.error')
  }
}

export const getPersonRiskGroupStatus = (
  t: TFunction,
  status: PersonScreeningStatus
) => {
  const statusMap = {
    [PersonScreeningStatus.NEW]: {
      color: 'gold',
      text: t('pre_screening.new')
    },
    [PersonScreeningStatus.NOT_FOUND]: {
      color: 'red',
      text: t('pre_screening.not_found')
    },
    [PersonScreeningStatus.PRE_SCREENING]: {
      color: 'green',
      text: t('pre_screening.pre_screening')
    }
  }

  return {
    color: statusMap[status].color ?? 'red',
    text: statusMap[status].text ?? t('pre_screening.error')
  }
}

export const getPersonRiskGroupSelectOptions = (t: TFunction) => {
  const statusMap = {
    [PersonScreeningStatus.NEW]: t('pre_screening.new'),
    [PersonScreeningStatus.NOT_FOUND]: t('pre_screening.not_found'),
    [PersonScreeningStatus.PRE_SCREENING]: t('pre_screening.sent')
  }

  return (Object.keys(statusMap) as PersonScreeningStatus[]).map((status) => ({
    value: status,
    label: statusMap[status]
  }))
}
